import CalculateServiceApi from 'api/calculate-service-api';
import {useMutation} from 'react-query';
import {saveCalculationMutationKey} from 'constants/query';

export function useSaveCalculationMutation() {
  return useMutation([saveCalculationMutationKey], (CalculationId) =>
    CalculateServiceApi.saveCalculation({CalculationId}),
  );
}
